<template>
  <div>
    <div class="field">
      <n-text-input
        v-model="value.image_url"
        label="Image URL"
        :errorMessage="getErrorMessage('image_url', 'Image URL')"
        @input="() => markAsTouched('image_url')"
      />
    </div>

    <div class="field">
      <n-text-input
        v-model="value.header_text"
        label="Header Text"
        :errorMessage="getErrorMessage('header_text', 'Header Text')"
        @input="() => markAsTouched('header_text')"
      />
    </div>

    <div class="field">
      <n-text-input
        v-model="value.body_text"
        label="Body Text"
        :errorMessage="getErrorMessage('body_text', 'Body Text')"
        @input="() => markAsTouched('body_text')"
      />
    </div>

    <div class="field">
      <n-text-input
        v-model="value.article_url"
        label="Article URL"
        :errorMessage="getErrorMessage('article_url', 'Article URL')"
        @input="() => markAsTouched('article_url')"
      />
    </div>

    <div class="field">
      <n-text-input
        v-model="value.link_label"
        label="Link Label"
        :errorMessage="getErrorMessage('link_label', 'Link Label')"
        @input="() => markAsTouched('link_label')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import useVuelidate from '@vuelidate/core';
import { required, url } from '@vuelidate/validators';
import { ArticleAppConfig } from './models/ArticleApp';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';

const props = defineProps({
  modelValue: {
    type: Object as PropType<ArticleAppConfig>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: ArticleAppConfig): void;
  (e: 'isInvalid', value: boolean): void;
}>();

const value = useVModel(props, 'modelValue', emit);

const validations = {
  image_url: { required, url },
  header_text: { required },
  body_text: { required },
  article_url: { required, url },
  link_label: { required },
};

const $v = useVuelidate(validations, value);

function markAsTouched(key: string & keyof ArticleAppConfig) {
  const field = $v.value[key];
  if (field) {
    field.$touch();
  }
  emit('isInvalid', $v.value.$invalid);
}

function getErrorMessage(fieldName: string & keyof ArticleAppConfig, label: string): string | null {
  return VuelidateUtil.getErrorMessage($v, fieldName, label);
}
</script>
